import {RouteDefinition} from '../../../routes';
import {UserEditScreen} from './UserEditScreen';
import {UserListScreen} from './UserListScreen';
import {UserEditPushTokenScreen} from './UserEditPushTokenScreen';

export const UserSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/users/edit',
        component: UserEditScreen,
    },
    {
        routerLink: '/settings/users/edit/:id',
        component: UserEditScreen,
    },
    {
        routerLink: '/settings/users',
        component: UserListScreen,
    },
    {
        routerLink: '/developer/users/edit-push-token',
        component: UserEditPushTokenScreen,
    },
];
